export default {
  namespaced: true,
  state: {
    all: [],
  },
  modules: {},
  getters: {
    getAll(state) {
      return state.all;
    },
    getAllByCategoryId: (state) => (categoryId) => {
      return state.all.filter(product => product.category_id === categoryId);
    },
    getPrices(state) {
      return state.all.map((value) => {
        return value.price * value.amount;
      });
    },
    getProductSummary(state, getters, globalState, globalGetters) {
      let products = state.all;
      let categories = globalGetters['categories/getAllCategories'];
      let notFoundProductSkus = globalGetters['order/getNotFoundProductSkus'];

      let result = {};

      if (products) {
        products.map((product) => {
          let category = categories.find((p) => {
            return p.id === product.category_id;
          })
          if (!result[category.name]) {
            result[category.name] = [];
          }
          if (product.amount > 0) {
            product.notFound = notFoundProductSkus.includes(product.sku);
            result[category.name].push(product);
          }
        })
      }
      return result;
    }
  },
  actions: {
    setProduct({state, commit}, payload) {
      let productIndex = state.all.findIndex((a) => {
        return a.id === payload.id;
      })

      if (productIndex >= 0) {
        if (payload.amount > 0) {
          commit('CHANGE_PRODUCT', {...payload, productIndex});
        } else {
          commit('REMOVE_PRODUCT', productIndex);
        }
      } else {
        commit('ADD_PRODUCT', payload)
      }
    },
    syncProductsByCategoryId({ state, commit }, { categoryId, products }) {
      const newBuildProducts = state.all
        .filter(buildProduct => buildProduct.category_id !== categoryId)
        .concat(products);

      commit('SET_ALL', newBuildProducts);
    },
  },
  mutations: {
    SET_ALL(state, values) {
      state.all = values;
    },
    ADD_PRODUCT(state, value) {
      state.all.push({...value})
    },
    CHANGE_PRODUCT(state, value) {
      state.all[value.productIndex].amount = value.amount;
    },
    REMOVE_PRODUCT(state, index) {
      state.all.splice(index, 1);
    },
    RESET(state) {
      state.all = [];
    }
  },
};
